import { render, staticRenderFns } from "./AddEditExpense.vue?vue&type=template&id=5960cdb4"
import script from "./AddEditExpense.vue?vue&type=script&lang=js"
export * from "./AddEditExpense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports